import { Box, Typography } from '@mui/material';
import { useProfileStyles } from '../styles';
import { OptionalTypography } from '../../settings-page/components';

export type IconWithContentProps = {
  icon: React.ReactNode;
  primary: string;
  secondary: React.ReactNode;
  disableSecondaryTypography?: boolean;
  secondaryOptional?: boolean;
  alignIcon?: 'flex-start' | 'center';
};

export const IconWithContent: React.VFC<IconWithContentProps> = props => {
  const { classes } = useProfileStyles();

  return (
    <Box display="flex" alignItems={props.alignIcon ?? 'center'} gap="0.5rem">
      <Box className={classes.iconContainer}>
        {props.icon}
      </Box>
      <Box display="flex" flexDirection="column" gap={{ xs: 0, sm: '0.25rem' }}>
        <Typography className={classes.fontWeight500}>{props.primary}</Typography>
        {props.disableSecondaryTypography ? props.secondary : <Typography component={props.secondaryOptional ? OptionalTypography : undefined}>{props.secondary}</Typography>}
      </Box>
    </Box>
  );
};
